export default class notasProxi {
    constructor(axios, url) {
        this.axios = axios;
        this.url = url;
    }

    /*==================== NOTAS DE 5TO 6TO 8VO 9NO 1ER BGU 2DO BGU=============================== */
    saveNotas(id, params) {
        return this.axios.put(this.url + `/common/${id}`, params);
    }
     
    supletorios(id, params) {
        return this.axios.put(this.url + `/common/supletorios/${id}`, params);
    }
  
    proyecto(id, params) {
        return this.axios.put(this.url + `/common/proyecto/${id}`, params);
    }

    ajustarCommon(id, params) {
        return this.axios.put(this.url + `/common/ajustar/${id}`, params);
    }

    /*==================== NOTAS DE 7MO 10MO 3ER BGU=============================== */
    saveNotasSub(id, params) {
        return this.axios.put(this.url + `/subnivel/${id}`, params);
    }
     
    supletoriosSub(id, params) {
        return this.axios.put(this.url + `/subnivel/supletorios/${id}`, params);
    }
  
    proyectoSub(id, params) {
        return this.axios.put(this.url + `/subnivel/proyecto/${id}`, params);
    }
    ajustarSub(id, params) {
        return this.axios.put(this.url + `/subnivel/ajustar/${id}`, params);
    }

     /*==================== NOTAS DE MATERIAS CUALITATIVOS=============================== */
     saveNotasCua(id, params) {
        return this.axios.put(this.url + `/cualitativo/${id}`, params);
    }

     /*==================== NOTAS DE MATERIAS ELEMENTAL=============================== */
     saveNotasEle(id, params) {
        return this.axios.put(this.url + `/elemental/${id}`, params);
    }
    saveNotasEleCuartos(id, params) {
        return this.axios.put(this.url + `/elemental/cuartos/${id}`, params);
    }
}

